import { render, staticRenderFns } from "./configuratore.html?vue&type=template&id=49a2f980&"
import script from "./Configuratore.vue?vue&type=script&lang=js&"
export * from "./Configuratore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports